import React from "react";
import { Result, Skeleton } from "antd";

const Loading = ({ loading = false, error = false, children }) => {
  return (
    <>
      {loading ? (
        <Skeleton active />
      ) : error ? (
        <Result
          status="error"
          title="Can't get data"
          subTitle="An error occured while getting the data."
        />
      ) : (
        children
      )}
    </>
  );
};

export default Loading;
